import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  constructor() { }

  validateLoginInput(user){
    if(user.username == undefined || user.password == undefined){
      return false;
    } else {
      return true;
    }
  }

  validateResetInput(user){
    if(user.newpassword == undefined || user.confirmpassword == undefined || user.token == undefined){
      return false;
    } else {
      return true;
    }
  }

  validateResetPassword(user){
    if(user.newpassword !== user.confirmpassword){
      return false;
    }else { 
      return true
    }
  }

  validateResetPasswordLength(user){
    if(user.newpassword.length >= 8 && user.newpassword.length <= 15){
      return false;
    }else { 
      return true
    }
  }

  validateForgetPasswordInput(user){
    if(user.username == undefined){
      return false;
    } else {
      return true;
    }
  }

  validateGetAgentInput(agent){
    if(agent.agent_id == undefined){
      return false;
    }else{
      return true;
    }
  }

  specialCharterCheck(data){
    // console.log(data)
    const check = /[!#$%^&*(),'?":{}|/<>]/;
    if(data.match(check)){
      return false;
    }else{
      return true;
    }
  }
  
}
